export default __webpack_public_path__ + "static/media/AceiteDePalta.9a7b53e4.jpeg";